import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-51">
      <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl shadow-black/50 flex flex-col animate-[modalIn_0.25s_ease-out]" onClick={e => e.stopPropagation()} data-id="element-52">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800" data-id="element-53">
          <h2 className="text-xl font-bold text-white" data-id="element-54">
            {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800 transition-colors" aria-label="Cerrar" data-id="element-55">
            <XIcon className="w-5 h-5" data-id="element-56" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-6 py-6 text-slate-300 text-sm leading-relaxed space-y-4" data-id="element-57">
          {type === 'privacy' ? <PrivacyContent data-id="element-58" /> : <TermsContent data-id="element-59" />}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-slate-800 text-center" data-id="element-60">
          <button onClick={onClose} className="px-6 py-2 bg-slate-800 hover:bg-slate-700 text-white text-sm font-medium rounded-lg transition-colors" data-id="element-61">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}
function PrivacyContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-62">Última actualización: Marzo 2026</p>

      <h3 className="text-lg font-semibold text-white" data-id="element-63">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-64">
        Al adquirir nuestro producto digital, recopilamos únicamente la
        información necesaria para procesar tu compra: nombre, dirección de
        correo electrónico y datos de pago. No almacenamos información de
        tarjetas de crédito en nuestros servidores.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-65">
        2. Uso de la Información
      </h3>
      <p data-id="element-66">
        Utilizamos tu información exclusivamente para: entregar el producto
        digital adquirido, enviar actualizaciones relacionadas con tu compra y
        brindarte soporte en caso de ser necesario. No vendemos, alquilamos ni
        compartimos tu información personal con terceros con fines comerciales.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-67">
        3. Protección de Datos
      </h3>
      <p data-id="element-68">
        Implementamos medidas de seguridad estándar de la industria para
        proteger tu información personal. Toda la comunicación entre tu
        navegador y nuestros servidores está encriptada mediante SSL/TLS.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-69">4. Cookies</h3>
      <p data-id="element-70">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para mejorar la experiencia del usuario. Podés desactivar las
        cookies en la configuración de tu navegador.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-71">5. Tus Derechos</h3>
      <p data-id="element-72">
        Tenés derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También podés solicitar la portabilidad de tus
        datos o retirar tu consentimiento para el procesamiento de los mismos.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-73">6. Modificaciones</h3>
      <p data-id="element-74">
        Nos reservamos el derecho de actualizar esta política de privacidad.
        Cualquier cambio será publicado en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-75">Última actualización: Marzo 2026</p>

      <h3 className="text-lg font-semibold text-white" data-id="element-76">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-77">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, aceptás estos términos y condiciones en su totalidad. Si no
        estás de acuerdo con alguna parte, te pedimos que no utilices nuestros
        servicios.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-78">2. Producto Digital</h3>
      <p data-id="element-79">
        El "Protocolo Reinicio" es un producto digital educativo e informativo.
        El contenido no reemplaza el consejo médico profesional, diagnóstico o
        tratamiento. Consultá siempre con un profesional de la salud calificado
        ante cualquier duda sobre tu condición médica.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-80">3. Licencia de Uso</h3>
      <p data-id="element-81">
        Al realizar la compra, se te otorga una licencia personal,
        intransferible y no exclusiva para usar el material. Queda prohibida la
        reproducción, distribución, modificación o reventa del contenido sin
        autorización expresa.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-82">
        4. Política de Reembolso
      </h3>
      <p data-id="element-83">
        Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los 7
        días posteriores a la compra no estás conforme con el producto, podés
        solicitar un reembolso completo sin necesidad de justificación.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-84">
        5. Limitación de Responsabilidad
      </h3>
      <p data-id="element-85">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. El contenido se proporciona "tal cual" y no nos
        hacemos responsables por decisiones tomadas en base a la información
        proporcionada.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-86">
        6. Propiedad Intelectual
      </h3>
      <p data-id="element-87">
        Todo el contenido, incluyendo textos, gráficos, audios y materiales
        descargables, es propiedad exclusiva de Protocolo Reinicio y está
        protegido por las leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="text-lg font-semibold text-white" data-id="element-88">7. Modificaciones</h3>
      <p data-id="element-89">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios entrarán en vigencia a partir de su publicación en
        este sitio.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#05070a] py-10 border-t border-slate-800/50 text-center text-slate-500 text-sm" data-id="element-90">
        <div className="max-w-7xl mx-auto px-4 space-y-4" data-id="element-91">
          <div className="flex items-center justify-center gap-6" data-id="element-92">
            <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-amber-400 transition-colors underline underline-offset-4 decoration-slate-700 hover:decoration-amber-400" data-id="element-93">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-94">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-amber-400 transition-colors underline underline-offset-4 decoration-slate-700 hover:decoration-amber-400" data-id="element-95">
              Términos y Condiciones
            </button>
          </div>

          <p data-id="element-96">
            © {new Date().getFullYear()} Protocolo Reinicio. Todos los derechos
            reservados.
          </p>

          <p className="text-xs opacity-60 max-w-xl mx-auto" data-id="element-97">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-98" />}

      <style data-id="element-99">{`
        @keyframes modalIn {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </>;
}